import { render, staticRenderFns } from "./FeedComponent.vue?vue&type=template&id=3e1bfbff&scoped=true"
import script from "./FeedComponent.vue?vue&type=script&lang=js"
export * from "./FeedComponent.vue?vue&type=script&lang=js"
import style0 from "./FeedComponent.vue?vue&type=style&index=0&id=3e1bfbff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bfbff",
  null
  
)

export default component.exports